export default {"src":"/login-app/[GIT_HASH]/_next/static/media/expand_fullscreen.5832aa85.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};